import { getPage } from "../page";
import { load } from "../events/load";
import animate from "./animations";

load(() => {
  if (getPage() === "home") {
    const list = [
      {
        selector: "#hero h1, #hero p",
        from: {
          opacity: 0,
          y: -50,
        },
        to: {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.1,
					delay: .5,
        },
      },
			{
        selector: "#hero p",
        from: {
          clipPath: "circle(0% at 0% 0%)",
        },
        to: {
          clipPath: "circle(150% at 0% 0%)",
          duration: 1,
					delay: .5,
        },
      },
      {
        selector: "#hero",
        from: {
          backgroundSize: "auto 100%",
        },
        to: {
          backgroundSize: "auto 120%",
          duration: 1,
					delay: .5,
        },
      },
			{
				selector: "#hero",
				from: {
					backgroundPosition: "center 100%",
				}, 
				to: {
					backgroundPosition: "center 0",
					scrollTrigger: {
						trigger: "#hero",
						start: "bottom 90%",
						end: "bottom 0%",
						scrub: true,
					}
				}
			},
			{
				selector: "#hero p span",
				from: {
					backdropFilter: "blur(0px)",
				}, 
				to: {
					backdropFilter: "blur(11px)",
					duration: 1,
					delay: 1.5,
				}
			}
    ];
    // animate(list);
  }
});
